import { Grid, Heading, LogoShowcasePlain } from '@zappyrent/hundop';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import logoIstitutoEuropeoDiDesign from '../../images/logos/IstitutoEuropeoDiDesign.svg';
import logoPolitecnicoDiMilano from '../../images/logos/PolitecnicoDiMilano.svg';
import logoPWC from '../../images/logos/PWC.svg';
// import logoUniversitaBocconi from '../../images/logos/UniversitaBocconi.svg';
import logoUniversitaCattolica from '../../images/logos/UniversitaCattolica.svg';
import { StyledHeadingWrapper } from './OurPartnerships.styles';

const OurPartnerships = (): JSX.Element => {
  const { t } = useTranslation('product');

  return (
    <>
      <Grid container>
        <StyledHeadingWrapper>
          <Heading tag="h3" sm="24px" md="24px" lg="24px">
            <Trans i18nKey="ourPartnerships" t={t} />
          </Heading>
        </StyledHeadingWrapper>
        <LogoShowcasePlain
          content={[
            {
              imageAlt: 'Università Cattolica',
              imageSrc: logoUniversitaCattolica,
              imageHeight: {
                sm: '48px',
                lg: '48px',
              },
            },
            // {
            //   imageAlt: 'Università Commerciale Luigi Bocconi',
            //   imageSrc: logoUniversitaBocconi,
            //   imageHeight: {
            //     sm: '48px',
            //     lg: '48px',
            //   },
            // },
            {
              imageAlt: 'Istituto Europeo di Design',
              imageSrc: logoIstitutoEuropeoDiDesign,
              imageHeight: {
                sm: '48px',
                lg: '48px',
              },
            },
            {
              imageAlt: 'Politecnico di Milano',
              imageSrc: logoPolitecnicoDiMilano,
              imageHeight: {
                sm: '48px',
                lg: '48px',
              },
            },
            {
              imageAlt: 'PWC',
              imageSrc: logoPWC,
              imageHeight: {
                sm: '48px',
                lg: '48px',
              },
            },
          ]}
        />
      </Grid>
    </>
  );
};

export default OurPartnerships;
